
import lodashIsNull from 'lodash/isNull';
import lodashCloneDeep from 'lodash/cloneDeep';
import lodashIsEmpty from 'lodash/isEmpty';
import _ from 'lodash';


export function isNull(value: any): value is null {
    return lodashIsNull(value);
}

export function cloneDeep(obj: any) {
    return lodashCloneDeep(obj);
}

export function isNotEmptyObject(obj: any): boolean {
    return _.isPlainObject(obj) && !_.isEmpty(obj);
} 
export function isEmpty(value: any): boolean {
    return lodashIsEmpty(value);
}